// React
import PropTypes from "prop-types";

// @mui material components
import { Card, CircularProgress, Fade, Icon, Modal, Tooltip } from "@mui/material";

// Custom UI components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "40%", xxl: "30%" },
  overflow: "auto",
};

export default function ModalFinalizarProveedor({ open, handleClose, handleSave,loading }) {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox>
              <SoftBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                pb={0}
              >
                <SoftBox>
                  <SoftTypography variant="h6">Confirmar creación de cuenta</SoftTypography>
                </SoftBox>
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
              <SoftBox p={3}>
                <SoftTypography variant="h6" fontWeight="light">
                  Una vez creada la cuenta, deberá esperar la aprobación por parte de la administración.
                  <br />
                  <strong>¿Desea continuar con la creación de la cuenta? </strong>
                </SoftTypography>
              </SoftBox>
            </SoftBox>
            <SoftBox display="flex" justifyContent="end" alignItems="center" p={3} pt={0}>
              <SoftBox mr={2}>
                <SoftButton color="primary" circular onClick={handleClose} disabled={loading}>
                  <Icon sx={{ fontWeight: "light" }}>arrow_back</Icon>
                  &nbsp;Volver
                </SoftButton>
              </SoftBox>
              <SoftBox>
                <SoftButton color="uproGreen" circular onClick={handleSave} disabled={loading}>
                  {loading ? (
                    <CircularProgress size={15} sx={{ color: "white" }} />
                  ) : (
                    <Icon sx={{ fontWeight: "light" }}>done</Icon>
                  )}
                  &nbsp;Confirmar
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalFinalizarProveedor.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  setDevolucion: PropTypes.func,
  handleSave: PropTypes.func,
  loading: PropTypes.bool,
};
